//'use strict';

//$(document).bind('touchmove', false);


var wbApp = angular.module('wbApp', [
  'ngAnimate',
  'mgcrea.ngStrap',
  'pascalprecht.translate',
  'ngRoute',
  'ngResource',  
  'ngSanitize',
  'wb.directives',  
  //'http-auth-interceptor',
  'services.breadcrumbs',
  'textAngular',
  //'authDirectives',
  'angulartics',
  'angulartics.google.analytics',
  'googlechart',
  'LocalStorageModule',
  'WBGrid',
  'ngImgCrop',
  'angular-loading-bar',
  'uiGmapgoogle-maps',
  'jkuri.gallery',
  'dx'
]).run(['$rootScope', '$translate', function ($rootScope, $translate) {
    $rootScope.$on("$routeChangeSuccess", function (event, currentRoute, previousRoute) {
        $rootScope.title = $translate.instant(currentRoute.label);
    });
}]);

wbApp.config(['$logProvider',
    function ($logProvider) {
    $logProvider.debugEnabled(true);
}]);

wbApp.config(['$datepickerProvider', function ($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
        startWeek: 1,
        autoclose: true,
        container: 'body',
        useNative: true,
        dateFormat: 'd.M.yyyy'
    });
}]);


wbApp.config(['$timepickerProvider', function ($timepicketProvider) {
    angular.extend($timepicketProvider.defaults, {
        autoclose: true,
        //container: 'body',
        useNative: true,        
        timeFormat: 'H:mm'
    });
}]);

wbApp.config(['$modalProvider', function ($modalProvider) {
    angular.extend($modalProvider.defaults, {
        animation: 'am-fade-and-slide-top',
        placement: 'center',
        backdrop: 'static',
    });
}]);

wbApp.config(['$popoverProvider', function($popoverProvider) {
    angular.extend($popoverProvider.defaults, {
        container: 'body',
        html: true
    });
}]);

wbApp.config(['localStorageServiceProvider', function (localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('wbAppNgAdmin');
    localStorageServiceProvider.setStorageType('localStorage');
    localStorageServiceProvider.setNotify(true, true);
}]);


//var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;
//var regexIso8601 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|([\-+])(\d{2}):(\d{2}))?$/;

function convertDateStringsToDates(input) {
    // Ignore things that aren't objects.
    if (typeof input !== "object") return input;

    for (var key in input) {
        if (!input.hasOwnProperty(key)) continue;

        var value = input[key];
      //  var match;
        // Check for string properties which look like dates.
        if (typeof value === "string" && isNaN(value)) {
            var date = moment(value, moment.ISO_8601);
            if (date.isValid()) {
                input[key] = date.toDate();
            }
        } else if (typeof value === "object") {
            // Recurse into object
            convertDateStringsToDates(value);
        }
    }
}

// If the property is Date and property name ends with Utc than it converts from local to Utc and appends Z to resulting string
function convertDatesToDateString(input) {

    return _.cloneDeepWith(input, function (value, key) {
        if (value instanceof Date) {
            var date = moment(value);
            if (date.isValid()) {
                if (isNaN(key) && key.endsWith('Utc')) {
                    return date.utc().format();
                } else {
                    return date.format('YYYY-MM-DDTHH:mm:ss');
                }
            }
        }
    });
}

wbApp.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.defaults.transformResponse.push(function (data, headerGetter) {
        convertDateStringsToDates(data);
        return data;
    });

    $httpProvider.defaults.transformRequest.push(function (data, header) {
        return data;
    });
}]);


wbApp.config(['$translateProvider', function ($translateProvider) {
    $translateProvider
        .useSanitizeValueStrategy(null);
    $translateProvider
        .preferredLanguage('en');
}]);


// Strip the timezone
Date.prototype.toISOString = function () {
    return moment(this).format('YYYY-MM-DDTHH:mm:ss');
};

wbApp.constant('tenantInfo', tenantInfo);
wbApp.constant('preferredLanguage', preferredLanguage);

wbApp.config(['uiGmapGoogleMapApiProvider', function (uiGmapGoogleMapApiProvider) {
    uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyDgac1ahn5_WNYnb1b0TgRf7Q_JhM3ZRQc',
        v: '3.20', //defaults to latest 3.X anyhow
        libraries: 'weather,geometry,visualization'
    });
}]);


Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) { s = "0" + s; }
    return s;
}


